import { request } from '@/utils/request'

export default {
  leaveFormSubmit: (params, loading) => {
    return request('/api/web/consult', params, loading)
  },
  aboutUsShow: (params, loading) => {
    return request('/api/web/commonwebsite/info', params, loading)
  },
  websitetemplate: (params, loading) => {
    return request('/api/web/websitetemplate/info', params, loading)
  },
  buyServiceApi: (params, loading) => {
    return request('/api/web/purchaseproductinfo/list', params, loading)
  }, 
  newsInfo: (params, loading) => {
    return request('/api/web/news', params, loading)
  },
  newsDetailInfo: (params, loading) => {
    return request('/api/web/news/detail', params, loading)
  },
  aboutInfo: (params, loading) => {
    return request('/api/web/relation', params, loading)
  },
}



// WEBPACK FOOTER //
// ./src/api/other.js